import React from "react";
import useDisclaimerContent from "../../../../hooks/shared/useDisclaimerContent";
import { BnbLabel } from "../../../../utils/labels";
import Disclaimer from "./Disclaimer";
import * as DisclaimerStyles from "../../../../../../../common-deprecated/styles/v2/toyota/components/Disclaimer";
import { IntegratedLegalBannerDisclaimer } from "../../../../../../shared-components/toyota/IntegratedLegalBannerDisclaimer";

type DisclaimerContainerPropsType = {
    showGenericFinanceDisclaimer?: boolean;
    hasDarkBackground?: boolean;
};
const DisclaimerContainer = (props: DisclaimerContainerPropsType): JSX.Element | null => {
    const { showGenericFinanceDisclaimer = false, hasDarkBackground } = props;

    const disclaimers = useDisclaimerContent(showGenericFinanceDisclaimer);

    return disclaimers.items.length > 0 || disclaimers.legalBannerDisclaimerData ? (
        <DisclaimerStyles.DisclaimerContainer>
            {disclaimers.legalBannerDisclaimerData && (
                <IntegratedLegalBannerDisclaimer data={disclaimers.legalBannerDisclaimerData} />
            )}
            <DisclaimerStyles.Title>
                <BnbLabel label="disclaimers" />
            </DisclaimerStyles.Title>
            <DisclaimerStyles.DisclaimerList role="list">
                {disclaimers.items.map((disc) => (
                    <Disclaimer disclaimer={disc} key={disc.id} hasDarkBackground={hasDarkBackground} />
                ))}
            </DisclaimerStyles.DisclaimerList>
        </DisclaimerStyles.DisclaimerContainer>
    ) : null;
};

export default DisclaimerContainer;
